import editor from "./editor";
import mediaQueries from "./media-queries";
import icons from "../imgs/icons";

const rightCol = {
  ...editor.rightCol,
  [mediaQueries.desktop]: {
    ...editor.rightCol[mediaQueries.desktop],
    marginTop: 0
  }
};

const filterOptionsTitle = {
  ...editor.title,
  [mediaQueries.tablet]: {
    display: "none"
  }
};

const filterOptions = {
  display: "flex",
  flexWrap: "wrap",
  cursor: "pointer",
  marginLeft: "-5px",
  marginRight: "-5px"
};

const previewThumb = {
  cursor: "pointer",
  position: "relative",
  flex: "0 0 33.333333%",
  maxWidth: "33.333333%",
  paddingLeft: "5px",
  paddingRight: "5px",
  margin: "5px 0"
};

const thumbWrapper = (isActive) => {
  const style = {};
  style.height = "70px";
  if (isActive) {
    style.border = "2px solid #D5C17D";
    style.padding = "4px";
    style["&:before"] = {
      content: "''",
      background: `url(${icons.tick}) no-repeat`,
      position: "absolute",
      width: "30px",
      height: "24px",
      top: "50%",
      left: "50%",
      marginTop: "-12px",
      marginLeft: "-15px"
    };
  }
  style.position = "relative";
  style.width = "100%";
  style.cursor = "pointer";
  style.marginBottom = "0";
  return style;
};

const filterName = {
  fontFamily: "JWSansBook",
  fontSize: "12px",
  color: "#000000",
  letterSpacing: "0.45px",
  textAlign: "center",
  lineHeight: "26px",
  margin: "4px 0 0"
};

const thumb = (src) => {
  const style = {};
  style.height = "100%";
  style.background = `url(${src}) center center `;
  style.backgroundSize = "cover";
  return style;
};

export default {
  rightCol,
  previewThumb,
  filterOptions,
  filterOptionsTitle,
  thumbWrapper,
  thumb,
  filterName
};



// WEBPACK FOOTER //
// ./src/styles/filter.js